$(document).ready(function () {
    const menu = document.getElementById('category-mega-menu');
    const trigger = document.querySelector('.category-mega-trigger');
    if (!menu || !trigger) return;
    const navigationRow = trigger.closest('.menu-main');
    if (!navigationRow) return;
    const sections = Array.from(menu.querySelectorAll('.category-mega__section'));
    function position() {
        const row = navigationRow.getBoundingClientRect();
        const top = Math.max(8, Math.min(row.bottom + 8, window.innerHeight - 120));
        menu.style.top = top + 'px';
        menu.style.maxHeight = Math.max(100, window.innerHeight - top - 12) + 'px';
    }
    function close(restoreFocus) {
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) trigger.focus();
    }
    function select(section) {
        sections.forEach(function (button) {
            const active = button === section;
            button.setAttribute('aria-expanded', String(active));
            document.getElementById(button.getAttribute('aria-controls')).hidden = !active;
        });
    }
    trigger.addEventListener('click', function (event) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (!menu.hidden) { close(false); return; }
        menu.hidden = false;
        menu.scrollTop = 0;
        trigger.setAttribute('aria-expanded', 'true');
        if (sections.length) select(sections[0]);
        position();
    });
    trigger.addEventListener('keydown', function (event) {
        if (event.key === ' ') { event.preventDefault(); trigger.click(); }
    });
    sections.forEach(function (section) {
        section.addEventListener('click', function () { select(section); });
    });
    menu.querySelector('.category-mega__close').addEventListener('click', function () { close(true); });
    document.addEventListener('click', function (event) {
        if (!menu.hidden && !menu.contains(event.target) && !trigger.contains(event.target)) close(false);
    });
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !menu.hidden) close(true);
    });
    document.addEventListener('focusin', function (event) {
        if (!menu.hidden && !menu.contains(event.target) && !trigger.contains(event.target)) close(false);
    });
    window.addEventListener('resize', function () {
        if (window.innerWidth < 992) close(false);
        else if (!menu.hidden) position();
    });
    window.addEventListener('scroll', function () { if (!menu.hidden) close(false); }, {passive: true});
});
